module.exports = __webpack_public_path__ + "img/signIn.ce74e327.png";